import { createBrowserRouter } from 'react-router-dom';
import Dashboard from '../pages/Static-Pages/Dashboard/Dashboard';
import AppLayout from '../pages/layout/AppLayout';
import AboutUs from '../pages/Static-Pages/About_Us/AboutUs';
import BecomePartner from '../pages/Static-Pages/Become_Partner/BecomePartner';
import ContactUs from '../pages/Static-Pages/Contact/ContactUs';
import PrivacyPolicyPage from '../pages/Static-Pages/Privacy_Policy/PrivacyPolicyPage';
import TermAndConditionsPage from '../pages/Static-Pages/Privacy_Policy/TermAndConditionsPage';
import AppPrivacyPolicy from '../pages/Static-Pages/Privacy_Policy/AppPrivacyPolicy';
import FAQPage from '../pages/Static-Pages/Privacy_Policy/FAQPage';
import UserProfilePage from '../pages/Dynamic-Pages/Users/Profile/UserProfilePage';
import OurProductsPage from '../pages/Dynamic-Pages/Products/Our-Products/OurProductsPage';
import ProductDetailsPage from '../pages/Dynamic-Pages/Products/Product-Details/ProductDetailsPage';
import SignUpPage from '../pages/Dynamic-Pages/Users/SignUp/SignUpPage';
import UserAddressPage from '../pages/Dynamic-Pages/Users/Address/UserAddressPage';
import CreateUserAddressPage from '../pages/Dynamic-Pages/Users/CreateAddress/CreateUserAddressPage';
import ProductCartPage from '../pages/Dynamic-Pages/Products/Cart/ProductCartPage';
import BillingInfoPage from '../pages/Dynamic-Pages/Products/Billing-Info/BillingInfoPage';
import OrderDetailsPage from '../pages/Dynamic-Pages/Orders/Details/OrderDetailsPage';
import ProtectedRoute from './ProtectedRoute';
import OTPVerifyPage from '../pages/Dynamic-Pages/Auth/OTPVerifyPage';
import UserLoginPage from '../pages/Dynamic-Pages/Auth/UserLoginPage';
import OrderHistoryPage from '../pages/Dynamic-Pages/Orders/History/OrderHistoryPage';
import NotFoundPage from '../pages/Dynamic-Pages/Error/NotFoundPage';
import RewardPage from '../pages/Static-Pages/Reward/RewardPage';
import GuestRoute from './GuestRoute';

export const router = createBrowserRouter([
  /** Public Routes */
  {
    path: '/',
    element: <Dashboard />,
  },

  /**Define Public Routes */
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'home', element: <Dashboard /> },
      { path: 'about', element: <AboutUs /> },
      { path: 'partner', element: <BecomePartner /> },
      { path: 'contact', element: <ContactUs /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-conditions', element: <TermAndConditionsPage /> },
      { path: 'app-policy', element: <AppPrivacyPolicy /> },
      { path: 'faq', element: <FAQPage /> },
      {
        path: 'login',
        element: (
          <GuestRoute>
            <UserLoginPage />
          </GuestRoute>
        ),
      },
      {
        path: 'sign-up',
        element: (
          <GuestRoute>
            <SignUpPage />
          </GuestRoute>
        ),
      },
      // { path: 'login', element: <UserLoginPage /> },
      // { path: 'sign-up', element: <SignUpPage /> },
      { path: 'otp-verify', element: <OTPVerifyPage /> },
      // { path: 'reward', element: <RewardPage /> },
      { path: 'products', element: <OurProductsPage /> },
      { path: 'product/details/:itemCode', element: <ProductDetailsPage /> },

      /** Define Private Route  */
      {
        path: 'user/',
        element: <ProtectedRoute />,
        children: [
          { path: 'address', element: <UserAddressPage /> },
          { path: 'create-address', element: <CreateUserAddressPage /> },
          {
            path: 'edit-address/:addressId',
            element: <CreateUserAddressPage />,
          },
          { path: 'profile', element: <UserProfilePage /> },
        ],
      },
      /**   Routes For product */
      {
        path: 'product/',
        element: <ProtectedRoute />,
        children: [
          { path: 'cart', element: <ProductCartPage /> },
          { path: 'billing-info', element: <BillingInfoPage /> },
        ],
      },
      /** Routes For orders */
      {
        path: 'orders/',
        element: <ProtectedRoute />,
        children: [
          { path: 'details/:orderId', element: <OrderDetailsPage /> },
          { path: 'history', element: <OrderHistoryPage /> },
        ],
      },

      /** 404 Not Found Page */
      // { path: '*', element: <NotFoundPage /> },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
